import { basePathIcons, SvgIcon } from '@y42/core/icon';

const iconsBasePath = `${basePathIcons}/ag-grid-headers-icons`;

export const agGridTableIcon: SvgIcon = `${iconsBasePath}/table.svg`;
export const agGridJobIcon: SvgIcon = `${iconsBasePath}/job.svg`;
export const agGridTagIcon: SvgIcon = `${iconsBasePath}/tag.svg`;
export const agGridTabIcon: SvgIcon = `${iconsBasePath}/tab.svg`;
export const agGridWidgetIcon: SvgIcon = `${iconsBasePath}/widget.svg`;
export const agGridOrchestrationIcon: SvgIcon = `${iconsBasePath}/orchestration.svg`;
export const agGridTriggersIcon: SvgIcon = `${iconsBasePath}/triggers.svg`;
export const agGridLastUsedIcon: SvgIcon = `${iconsBasePath}/last-used.svg`;
export const agGridScheduleIcon: SvgIcon = `${iconsBasePath}/schedule.svg`;
export const agGridTerminalIcon: SvgIcon = `${iconsBasePath}/terminal.svg`;
